if (!customElements.get('sticky-header')) {
  class EcbStickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      if (!this.header) return;

      this.stickyType = this.getAttribute('data-sticky-type') || 'always';
      this.headerIsAlwaysSticky = this.stickyType === 'always' || this.stickyType === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.setHeaderHeight();
      this.onResizeHandler = this.setHeaderHeight.bind(this);
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => {
        this.preventReveal = true;
      };

      window.addEventListener('resize', this.onResizeHandler);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      if (this.stickyType !== 'none') {
        window.addEventListener('scroll', this.onScrollHandler, { passive: true });
        this.createObserver();
      }

      if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');

      this.querySelectorAll('details').forEach((details) => {
        details.addEventListener('toggle', () => {
          const summary = details.querySelector(':scope > summary');
          if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
        });
      });

      this.querySelectorAll('.ecb-nav__details').forEach((details) => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          this.querySelectorAll('.ecb-nav__details[open]').forEach((openDetails) => {
            if (openDetails !== details) openDetails.removeAttribute('open');
          });
        });
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResizeHandler);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.isScrolling) window.clearTimeout(this.isScrolling);
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }

    createObserver() {
      const observer = new IntersectionObserver((entries) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventHide) requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = window.setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      if (this.predictiveSearch && this.predictiveSearch.isOpen) this.predictiveSearch.close();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.querySelectorAll('header-menu').forEach((disclosure) => disclosure.close());
    }
  }

  customElements.define('sticky-header', EcbStickyHeader);
}
